import { render, staticRenderFns } from "./ClaimPaymentManagement.vue?vue&type=template&id=1340db54"
import script from "./ClaimPaymentManagement.vue?vue&type=script&lang=js"
export * from "./ClaimPaymentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports